import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  onboarding: {
    name: "",
    nickname: "", // optional
    language: "",
    location: "", // optional
    age: "",
    llm: "",
    profilePicture: "",
    occupation: "",
    workOrStudyStatus: [],
    personality: [],
    goals: {
      productivityAndWork: [],
      careerAndEducation: [],
      personalWellBeing: [],
      creativeAndExpressive: [],
      skillsAndHobbies: [],
    },
    interests: {
      professionalInterests: [],
      creativeAndCultural: [],
      healthAndLifestyle: [],
      scienceAndLearning: [],
      other: "",
    },
    communicationPreferences: {
      toneOfVoice: [],
      purposeAndFormat: [],
      creativeAndNarrative: [],
      professionalAndAcademic: [],
      other: "",
    },
    other: "",
    questions: {
      q1: "",
      q2: "",
      q3: "",
      q4: "",
      q5: "",
      q6: "",
      q7: "",
      q8: "",
    },
  },
};

export const onboardingSlice = createSlice({
  name: "onboarding",
  initialState,
  reducers: {
    setOnboarding: (state, action) => {
      state = {
        ...state,
        onboarding: { ...state.onboarding, ...action.payload },
      };
      return state;
    },
  },
});

// Action creators are generated for each case reducer function
export const { setOnboarding } = onboardingSlice.actions;

export default onboardingSlice.reducer;
